// extracted by mini-css-extract-plugin
export var displayNone = "_rf-6";
export var imgContainer = "_rf-2";
export var overflowHidden = "_rf-3";
export var productInfoCardButtonContainer = "_rf-5";
export var productTitleText = "_rf-4";
export var rightArrow = "_rf-1";
export var rightArrowContainer = "_rf-0";